import React from 'react';
import { Body, Container } from '../../atoms';
export default function SimpleContentSection(param) {
    var variant = param.variant, children = param.children, style = param.style, className = param.className;
    return /*#__PURE__*/ React.createElement(Container, {
        name: SimpleContentSection.name,
        style: style,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-sm"
    }, /*#__PURE__*/ React.createElement(Body, {
        className: "prose",
        variant: variant
    }, children)));
}

//# sourceMappingURL=SimpleContentSection.js.map